import { render, staticRenderFns } from "./VisitedProducts.vue?vue&type=template&id=356411b1&"
import script from "./VisitedProducts.vue?vue&type=script&lang=js&"
export * from "./VisitedProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports